/**
 * Prefetches the next collection page HTML (`?page=N`) so `<load-more>` can use
 * the same buffer as `createBufferedPage`. Cleared on facets updates and when
 * `<load-more>` connects (orphan in-flight fetches are aborted).
 */
window.McLoadMorePrefetch = window.McLoadMorePrefetch || {
  /** @type {{ key: number, value: string } | null} */
  _pending: null,
  /** @type {AbortController | null} */
  _flight: null,

  clear() {
    if (this._flight) {
      this._flight.abort();
      this._flight = null;
    }
    this._pending = null;
  },

  /**
   * @returns {{ key: number, value: string } | null}
   */
  take() {
    const p = this._pending;
    this._pending = null;
    return p;
  },

  /**
   * @param {number} pageNum Shopify `page` query (same as createBufferedPage).
   */
  startPrefetch(pageNum) {
    this.clear();
    const ac = new AbortController();
    this._flight = ac;
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(pageNum));
    fetch(url, { signal: ac.signal })
      .then((r) => r.text())
      .then((html) => {
        if (this._flight !== ac) return;
        this._flight = null;
        this._pending = { key: pageNum, value: html };
      })
      .catch(() => {
        if (this._flight === ac) {
          this._flight = null;
        }
      });
  },
};

class LoadMore extends HTMLElement {
    constructor() {
        super();
        this.utils = new Utils()
        this.url = '{{ url }}';
        this.itemPerPage = parseInt('{{ perPage }}');
        this.button = this.querySelector('button');
        this.bufferedPage = {
            key: '',
            value: ''
        };

        this.setPageProperties();

        this.gridItemSelector = this.dataset.gridItem || 'li[data-product-item]';
        this.gridSelector = this.dataset.grid || '[data-product-grid]'
        this.gridElem = document.querySelector(this.gridSelector);
    }

    setPageProperties() {
        this.totalPages = this.getAttribute('data-total-pages');
    }

    connectedCallback() {
        const pref = window.McLoadMorePrefetch?.take?.();
        if (pref && pref.key === 2 && pref.value) {
            this.bufferedPage = { key: 2, value: pref.value };
        }
        window.McLoadMorePrefetch?.clear?.();

        this.dataset.itemPerPage = this.itemPerPage;
        this.handleCurrentPagination();
        this.listener();

        subscribe(PUB_SUB_EVENTS.facetsUpdate, () => {
            this.bufferedPage = {
              key: "",
              value: "",
            };
            window.McLoadMorePrefetch?.clear?.();
        });
        this.createBufferedPage(2);

        history.scrollRestoration = 'auto';
    }

    listener() {
        this.button?.addEventListener('click', async (e) => {
            this.handleAction()
        });

        window.addEventListener('scroll', () => {
            if ( this.utils.isElementVisible(this) && !this.classList.contains('tw-hidden')) {
                this.handleAction()
            }
        })
    }

    handleAction() {
        const url = new URL(location);
        const curPage = parseInt(url.searchParams.get('pagination')) || 1;
        url.searchParams.set('pagination', curPage + 1);
        history.pushState(null, null, url.toString());
        this.renderContent();
        this.createBufferedPage(curPage + 2);
    }


    async createBufferedPage(bufferPage) {
        if (this.bufferedPage.key === bufferPage && this.bufferedPage.value) {
            return;
        }
        const url = new URL(location);
        url.searchParams.set("page", bufferPage);
        const response = await fetch(url);
        this.bufferedPage.key = bufferPage;
        this.bufferedPage.value = await response.text();
      }

    getCurrentPage() {
        const url = new URL(window.location);
        return parseInt(url.searchParams.get('pagination'));
    }

    async handleCurrentPagination() {
        try {
            this.parentElement.toggleAttribute('loading', !0);
            const page = this.getCurrentPage();
            if (page) {
                for (let i = 2; i <= page; i++) {
                    const url = new URL(window.location);
                    url.searchParams.set('pagination', parseInt(i));
                    history.pushState(null, null, url.toString());
                    await this.renderContent();
                }
            }

            const url = new URL(window.location);
            this.createBufferedPage(parseInt(url.searchParams.get('pagination') || 1) + 1);

        } catch (err) {
            return this.parentElement.toggleAttribute('loading', !1), !1;
        }
    }

    async renderContent() {
        this.classList.add('tw-hidden');
        this.parentElement?.classList.add('loading');

        const page = this.getCurrentPage();

     
        let html;

        if (this.bufferedPage.key === page) {
            html = this.bufferedPage.value;
        } else {
            const response = await fetch(
                window.location.href.replace("pagination", "page")
              );
              html = await response.text();
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = document.createDocumentFragment();

        const newGridItems = doc.querySelectorAll(this.gridSelector + ' ' + this.gridItemSelector);

        newGridItems.forEach(item => {
            fragment.appendChild(item);
        });

        this.gridElem.appendChild(fragment);

        this.classList.toggle('tw-hidden', page >= parseInt(this.totalPages))

        this.setPageProperties();
        this.parentElement?.classList.remove('loading');

    }
}

customElements.define('load-more', LoadMore);
